/**
 * @param {object} context
 * @param {string} context.url
 * @param {string} context.userId
 * @param {object} context.query
 * @param {object} context.variations
 * @returns {string}
 */
function getCacheKey (context) {
  const keys = []

  let variations = context?.variations || {}
  variations = Object.values(variations)
    .map(ex => `${ex?.experimentKey}:${ex?.variationKey}`)
    .sort()

  let features = context?.features || {}
  features = Object.values(features)
    .map(fe => `${fe?.key}:enabled_${fe?.enabled}:${fe.id}:${JSON.stringify(fe?.variables)}`)
    .sort()

  let query = context?.query || {}
  query = Object.keys(query)
    .map(key => `${key}:${context.query?.[key]}`)
    .sort()

  if (context?.url) keys.push(context?.url?.replace(/\?.*$/, ''))
  if (context?.userId) keys.push(context?.userId)
  if (variations?.length) keys.push(variations.join('|'))
  if (features?.length) keys.push(features.join('|'))
  if (query?.length) keys.push(query.join('|'))

  return keys.join('|')
}

module.exports = { getCacheKey }
